require('oly-dialog');

angular.module('wowApp.common', ['oly.dialog', 'restangular']);

//-------------------------------------------
// Common filters
//-------------------------------------------
require('./filters');

// ------------------------------------------
// Components
// ------------------------------------------
require('./components/accordion');
require('./components/clearable-inputs');
require('./components/localStorage');
require('./components/bootstrap');
require('./components/feature');
require('./components/breakpoints');
require('./components/banners');
require('./components/animations');
require('./components/dropdown');
require('./components/wizard');
require('./components/urlinfo');
require('./components/confirmation-dialog');
require('./components/numeric');
require('./components/postcode');
require('./components/productgroup');
require('./components/notification');
require('./components/loading-spinner');
require('./components/autotab');
require('./components/valid-when');
require('./components/settings');
require('./components/disablepanel/');
require('./components/input');
require('./components/select');
require('./components/error-src');
require('./components/nexttab');
require('./components/autocomplete');
require('./components/guid/');
require('./components/grabfocus');
require('./components/movefocus');
require('./components/form-validation-summary');
require('./components/analytics');
require('./components/shared-timeout');
require('./components/user-preferences');
require('./components/button');
require('./components/tabs');
require('./components/images');
require('./components/sticky-header');
require('./components/images');
require('./components/resources');
require('./components/googlemaps');
require('./components/paging');
require('./components/repeatfinished');
require('./components/small-format-sizing');
require('./components/geolocation');
require('./components/openwindow');
require('./components/serializeasync');
require('./components/paypal');
require('./components/date-validator');
require('./components/servererrorfiller');
require('./components/scroll-to-element');
require('./components/expandable-content');
require('./components/on-repeat-finish');
require('./components/truncation');
require('./components/schema-markup');
require('./components/input-file-upload');
require('./components/state-class');
require('./components/route');
require('./components/mobile-set-store-notification');
require('./components/download-app-button');



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/common.module.js
 **/